import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class OverlayScrollLockService {
  private lockCount = 0;

  lock(): void {
    if (typeof document === 'undefined') {
      return;
    }

    this.lockCount += 1;

    if (this.lockCount > 1) {
      return;
    }

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const scrollableContainer = document.querySelector('.scrollable');
    if (scrollableContainer instanceof HTMLElement) {
      scrollableContainer.style.overflow = 'hidden';
      scrollableContainer.style.touchAction = 'none';
    }
  }

  unlock(): void {
    if (typeof document === 'undefined' || this.lockCount === 0) {
      return;
    }

    this.lockCount = Math.max(0, this.lockCount - 1);

    // Defensive fallback:
    // if internal counter gets out of sync but no overlay exists,
    // always release scroll lock to avoid stuck auth screens.
    const hasActiveOverlay = !!document.querySelector('app-modal, app-popup');
    if (this.lockCount > 0 && hasActiveOverlay) {
      return;
    }

    this.lockCount = 0;

    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    const containers = document.querySelectorAll<HTMLElement>('.scrollable');
    containers.forEach((el) => {
      el.style.overflow = '';
      el.style.touchAction = '';
    });

    // Extra cleanup: if any element still carries lock styles inline, clear them.
    const inlineLockedEls = document.querySelectorAll<HTMLElement>(
      '[style*="overflow: hidden"], [style*="touch-action: none"]'
    );
    inlineLockedEls.forEach((el) => {
      if (el.style.overflow === 'hidden') {
        el.style.overflow = '';
      }
      if (el.style.touchAction === 'none') {
        el.style.touchAction = '';
      }
    });
  }
}
